
const getRequest = async (endPoint, id) => {
  return ExecuteRequest(id, "get", endPoint, "");
};

const ExecuteRequest = (id, method, url, params, endPoint) => {
  const fetchOptions = {
    method: method,
    headers: {
      "Api-Type": "Alerts",
      "Content-Type": "application/json",
    },
  };
  if (method.toString().toLowerCase() !==  "get") {
    fetchOptions.body = JSON.stringify({
      Param: params,
      Endpoint: endPoint,
    });
  }

  //Enth my return 'in process', pause and try again
  return new Promise(async (onSuccess, onFailure) => {
    var pending = true;
    while (pending) {
      await fetch(url, fetchOptions)
        .then(async (response) => {
          if (url?.includes("login")) {
            console.log('FetchRequest::Promise() Login Async Response for ID: ', id);
            return await response.text();
          } else {
            console.log('FetchRequest::Promise() Promise Other Async Response for ID: ', id);
            return await response.json();
          }
        })
        .then((responseJson) => {
          if (responseJson) {
            console.log('FetchRequest::Promise() Promise responseJson for ID: ', id);
            if (responseJson.output === 'in process') {
              //wait and try again
              console.log('FetchRequest::Promise() ID: ', id, 'In Process');
            } else {
              pending = false;
              onSuccess(responseJson);
            }
          } else {
            console.log('FetchRequest::Promise() Error Encountered, responseJson is null for ID: ', id);
            pending = false;
            onFailure("Error Encounterd, responseJson is null");
          }
        })
        .catch((error) => {
          console.log('FetchRequest::Promise() Exception Encountered  for ID: ', id, error);
          pending = false;
          onFailure(error);
        });
        //if (pending)
         // console.log("searchResultsService::getResults() ID: ', id,  Pending");
      }
  });
};

export { getRequest };
